$(document).on('turbo:load', () => {
    // Use delegated event listener for kill-flash buttons
    $(document).on('click', '.kill-flash', (e) => {
        $(e.currentTarget).closest('.alert').remove();
    });
});